import { put, call, all, takeLatest } from 'redux-saga/effects';
import { signin as apiSignin, signup as apiSignup } from '../../../api';
import { setDefaultHeaders } from '../../../api/api';
import { signinSuccess, signFailure, resetErrors } from './actions';
import history from '../../../services/history';
import { profileRequest, signout as userSignout } from '../user/actions';
import { copyTrainingRoutine } from '../training-routine/actions';

function* handleSigninSuccess(token) {
  const bearerToken = `Bearer ${token}`;
  setDefaultHeaders({ authorization: bearerToken });
  yield put(signinSuccess(bearerToken));
  yield put(profileRequest()); // Save the logged user in redux
  history.push('/home');
}

function* signin({ payload }) {
  const { email, password } = payload;
  try {
    const {
      data: { token },
    } = yield call(apiSignin, { email, password });
    yield handleSigninSuccess(token);
  } catch (error) {
    yield put(signFailure());
  }
}

function* signup({ payload }) {
  const { name, email, password } = payload;
  try {
    const {
      data: { token },
    } = yield call(apiSignup, { name, email, password });
    yield handleSigninSuccess(token);
  } catch (error) {
    yield put(signFailure());
  }
}

function* signout() {
  yield put(userSignout()); // Remove user from redux
  yield put(copyTrainingRoutine(null));
  setDefaultHeaders(null);
  history.push('/');
}

// Handler of the action persist/REHYDRATE. If you want to set the default headers call `setDefaultHeaders` directly
function* rehydrateAuthHeader({ payload }) {
  const authorization = payload?.auth?.token ?? null;
  yield put(resetErrors());
  setDefaultHeaders({ authorization });
}

export default all([
  takeLatest('@auth/SIGN_IN_REQUEST', signin),
  takeLatest('@auth/SIGN_UP_REQUEST', signup),
  takeLatest('@auth/SIGN_OUT', signout),
  takeLatest('persist/REHYDRATE', rehydrateAuthHeader),
]);
